import { api } from '#proto/index.qonto.account_management';

export const ApiDowngradeStatus = api.organizations.deactivations.firstparty.v3.ApiDowngradeStatus;

export type ApiDowngradeStatus = (typeof ApiDowngradeStatus)[keyof typeof ApiDowngradeStatus];
